import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PurchaseDoneComponent, SharePickerResolver } from '@scaliolabs/baza-web-purchase-flow';
import { PurchaseCustomComponent } from './purchase-custom.component';

const routes: Routes = [
    {
        path: '',
        data: {
            layout: 'mini',
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'details',
            },
            {
                path: 'details',
                component: PurchaseCustomComponent,
                data: {
                    tab: '0',
                    meta: {
                        title: 'Purchase Details',
                    },
                },
            },
            {
                path: 'details-recurring',
                component: PurchaseCustomComponent,
                data: {
                    tab: '1',
                    meta: {
                        title: 'Recurring Details',
                    },
                },
            },
            {
                path: 'agreement',
                component: PurchaseCustomComponent,
                resolve: {
                    numberOfShares: SharePickerResolver,
                },
                data: {
                    tab: '2',
                    meta: {
                        title: 'Sign Agreement',
                    },
                },
            },
            {
                path: 'payment',
                component: PurchaseCustomComponent,
                resolve: {
                    numberOfShares: SharePickerResolver,
                },
                data: {
                    tab: '3',
                    meta: {
                        title: 'Submit Payment',
                    },
                },
            },
            {
                path: 'done',
                component: PurchaseDoneComponent,
                data: {
                    layoutParams: {
                        center: true,
                    },
                    meta: {
                        title: 'Done',
                    },
                },
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PurchaseRoutingCustomModule {}
